import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.css']
})
export class CopyComponent implements OnInit {
  category = "";
  constructor(
    public dialogRef: MatDialogRef<CopyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, ) {
    this.category = data.category;
  }

  select(type: string): void {
    this.dialogRef.close({ type: type });
  }

  ngOnInit() {
  }

}
